import React, { useEffect } from 'react';
import { useFieldArray } from 'react-hook-form';

export const GroupChecklist = ({ control, data, register }) => {
    const { fields: groupFields, replace } = useFieldArray({
        control,
        name: 'checklists',
    });

    useEffect(() => {
        if (data && data.length > 0) {
            replace(data);
        }
    }, [data, replace]);

    return (
        <div className="row mt-3">
            {groupFields.map((group, groupIndex) => (
                <div key={group.id} className="col-md-3">
                    <div className="mb-3">
                        <h4>{group.name}</h4>
                    </div>
                    {/* Group Checklists */}
                    {group.checklists && group.checklists.length > 0 ? (
                        group.checklists.map((checklist, checklistIndex) => (
                            <div key={checklist.id} className="form-check form-switch mb-2">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    {...register(`checklists.${groupIndex}.checklists.${checklistIndex}.isChecked`)}
                                    id={`switch-${checklist.id}`}
                                    value={checklist.id}
                                    defaultChecked={checklist.isChecked}
                                />
                                <label 
                                    className="form-check-label"
                                    htmlFor={`switch-${checklist.id}`}
                                >
                                    {checklist.name}
                                </label>
                            </div>
                        ))
                    ) : (
                        <p className="text-muted">No checklists available</p>
                    )}
                </div>
            ))}
        </div>
    );
};

export default GroupChecklist;
